import { type FC } from 'react'

import { ShowAtOrLarger, ShowWhenSmaller } from '@/components/shared/breakpoint'
import {
  AutocanBadgeImageIcon,
  AutocanLocalImage,
} from '@/components/vip/vip-autocan-features/styled'
import { type AutocanFeatureConfig } from '@/components/vip/vip-autocan-features/utils'

type BadgeWithLocalImageProps = Pick<
  AutocanFeatureConfig,
  'bgColor' | 'inlineBadgeImage' | 'mobileBadgeImage' | 'mobileIcon' | 'singleBadgeImage'
> & {
  useInlineVariant: boolean
}

/**
 * Image component for the autocan badge when it is NOT dynamic based on the listing
 */
export const BadgeWithLocalImage: FC<BadgeWithLocalImageProps> = ({
  bgColor,
  inlineBadgeImage,
  mobileBadgeImage,
  mobileIcon,
  singleBadgeImage,
  useInlineVariant,
}) => {
  return (
    <>
      <ShowAtOrLarger breakpoint="medium">
        <AutocanLocalImage
          alt=""
          bgColor={bgColor}
          src={useInlineVariant ? inlineBadgeImage : singleBadgeImage}
          useInlineVariant={useInlineVariant}
        />
      </ShowAtOrLarger>

      <ShowWhenSmaller breakpoint="medium">
        <AutocanLocalImage
          alt=""
          bgColor={bgColor}
          src={mobileBadgeImage}
          useInlineVariant={useInlineVariant}
        />

        {mobileIcon ? (
          <AutocanBadgeImageIcon
            alt=""
            height={56}
            src={mobileIcon}
            $useInlineVariant={useInlineVariant}
            width={56}
            data-testid="autocan-badge-mobile-icon"
          />
        ) : null}
      </ShowWhenSmaller>
    </>
  )
}
